// extracted by mini-css-extract-plugin
export default {"daysContent":"RallyDetails_daysContent__8pUaO","mobile-col":"RallyDetails_mobile-col__THqEd"};